import BaseWrapper from "../../components/ui/BaseWrapper";

const TalentPoolEngineersListingHeader = ({ currentTalentPool }) => {

  return (
    <>
      <div className="border-b border-zinc-300 bg-white">
        <BaseWrapper>
          <div className="py-[7px] flex justify-between">
            <h3 className="font-light">{currentTalentPool?.name}</h3>
          </div>
        </BaseWrapper>
      </div>
    </>
  );
};

export default TalentPoolEngineersListingHeader;
